import { DefaultBtn } from "../DefaultBtn/DefaultBtn";
import { Button } from "@aidron/aidron-ds";
import { i18n } from "../../../../translate/i18n";
import { CustomText } from "../../../../components/StyledComponents/styleComponents.index";
import { ErrorModal } from "../../../../components/SharedComponents/sharedComponents.index";

const { t } = i18n;

export const PurchaseRecommendationTableBtn = ({ actions, ctx, uiState }) => {

  const { 
    setShowInputs, 
    setShowCancelModal, 
    setShowUpdateRecommendationError, 
    onInputsSave, 
    setOpenOrderConfirmation 
  } = actions || {};

  const { suppliersAndProductRelations } = ctx || {};

  const { 
    showInputs, 
    showUpdateRecommendationError, 
    isPendingPurchaseOrders, 
    saveLoading,
    customDisabledCondition,
    errorOfPurchaseRecommendationUpdate,
    allowOrderSubmission 
  } = uiState || {};
  
  return (
    <div style={{ display: 'flex', gap: '1rem' }}>
      <DefaultBtn 
        actions={{
          setShowInputs: setShowInputs,
          setShowCancelModal: setShowCancelModal,
          onInputsSave: onInputsSave
        }}
        ctx={{ suppliersAndProductRelations: suppliersAndProductRelations }}
        uiState={{ showInputs: showInputs, customDisabledCondition: customDisabledCondition }}
      />

      {isPendingPurchaseOrders && (
        <Button 
          type={"outlined"} 
          onClick={() => setOpenOrderConfirmation(true)} 
          disabled={showInputs || !allowOrderSubmission} label={t("submitOrder")} />
      )}          

      {errorOfPurchaseRecommendationUpdate && (
        <ErrorModal 
          actions={{ onClose: setShowUpdateRecommendationError }}
          ctx={{
            page: 'purchase_recommendation_table',
            details: errorOfPurchaseRecommendationUpdate?.response?.data?.details,
            errorStatus: errorOfPurchaseRecommendationUpdate?.response?.status
          }}
          uiState={{
            isOpen: showUpdateRecommendationError,
            hasMoreThanOneItem: errorOfPurchaseRecommendationUpdate?.response?.data?.details?.length > 1
          }}
          
           />
      )}

      {saveLoading && (
        <CustomText fontSize={['0.4rem', '0.6rem', '1rem']} color="orange" weight="bold">
          {t("saving")}...
        </CustomText>
      )}
    </div>
  );      

}